/**
 * 리스트 조회 context
 */

import { Interval, afterDay } from "components/utils/comm";
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export type initialFilterStateProps = {
  sellSDt?: string;
  sellEDt?: string;
  resvSDt?: string;
  resvEDt?: string;
  cnlSDt: string;
  cnlEDt: string;
  resvCstFstnm: string;
  resvCstMblNo: string;
  memMobNo: string;
  memFstnm: string;
  sDt: string;
  eDt: string;
  dateTyp: string;
};
interface ResvCancelFilterContextType {
  filters: initialFilterStateProps;
  // initialFilterState: initialFilterStateProps;
  onChange: (name: string, value: string) => void;
  onSelect: (name: string, value: string) => void;
  onPickDate: (dates: Array<string>) => void;
  onReset: () => void;
}

// 2️⃣ Context 생성
const ResvCancelFilterContext = createContext<
  ResvCancelFilterContextType | undefined
>(undefined);

// 3️⃣ Provider Props 타입
interface ResvCancelFilterProviderProps {
  children: ReactNode;
}

// 4️⃣ Provider 컴포넌트
export const ResvCancelFilterProvider = ({
  children,
}: ResvCancelFilterProviderProps) => {
  const { sDt, eDt } = afterDay(Interval);
  const initialFilterState = {
    sellSDt: "",
    sellEDt: "",
    cnlSDt: "",
    cnlEDt: "",
    resvSDt: "",
    resvEDt: "",
    resvCstFstnm: "",
    resvCstMblNo: "",
    memMobNo: "",
    memFstnm: "",
    sDt: sDt,
    eDt: eDt,
    dateTyp: "sell",
  };

  const [filters, setFilters] =
    useState<initialFilterStateProps>(initialFilterState);

  const onChange = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onSelect = (name: string, value: string) => {
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  const onPickDate = (dates: Array<string>) => {
    setFilters({
      ...filters,
      sDt: dates[0],
      eDt: dates[1],
    });
  };

  const onReset = () => {
    setFilters(initialFilterState);
  };

  return (
    <ResvCancelFilterContext.Provider
      value={{
        filters,
        onChange,
        onSelect,
        onPickDate,
        onReset,
      }}
    >
      {children}
    </ResvCancelFilterContext.Provider>
  );
};

// 5️⃣ 커스텀 훅
export const useResvCancelFilterContext = (): ResvCancelFilterContextType => {
  const context = useContext(ResvCancelFilterContext);

  if (!context) {
    throw new Error(
      "useResvCancelFilterContext는 ResvCancelFilterProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};

// list Context 타입 정의
interface ResvCancelParamContextType {
  param: Partial<initialFilterStateProps> | undefined;
  setParam: Dispatch<
    SetStateAction<Partial<initialFilterStateProps> | undefined>
  >;
}

// 2️⃣ Context 생성
const ResvCancelParamContext = createContext<
  ResvCancelParamContextType | undefined
>(undefined);

// 3️⃣ Provider Props 타입
interface ResvCancelParamProviderProps {
  children: ReactNode;
}

// 4️⃣ Provider 컴포넌트
export const ResvCancelParamProvider = ({
  children,
}: ResvCancelParamProviderProps) => {
  const [param, setParam] = useState<
    Partial<initialFilterStateProps> | undefined
  >(undefined);

  return (
    <ResvCancelParamContext.Provider value={{ param, setParam }}>
      {children}
    </ResvCancelParamContext.Provider>
  );
};

// 5️⃣ 커스텀 훅
export const useResvCancelParamContext = (): ResvCancelParamContextType => {
  const context = useContext(ResvCancelParamContext);

  if (!context) {
    throw new Error(
      "useResvCancelParamContext RoomListProvider 내부에서만 사용해야 합니다."
    );
  }

  return context;
};
